/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./socket-io.component";
import * as i2 from "@ngrx/store";
import * as i3 from "./socket.io.service";
import * as i4 from "../share/share-errors.service";
var styles_SocketIoComponent = [];
var RenderType_SocketIoComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_SocketIoComponent, data: {} });
export { RenderType_SocketIoComponent as RenderType_SocketIoComponent };
export function View_SocketIoComponent_0(_l) { return i0.ɵvid(0, [i0.ɵncd(null, 0)], null, null); }
export function View_SocketIoComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "nns-socket-io", [], null, null, null, View_SocketIoComponent_0, RenderType_SocketIoComponent)), i0.ɵdid(1, 245760, null, 0, i1.SocketIoComponent, [i2.Store, i3.SocketIoService, i4.ShareErrorsService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SocketIoComponentNgFactory = i0.ɵccf("nns-socket-io", i1.SocketIoComponent, View_SocketIoComponent_Host_0, { shareCopy: "shareCopy" }, {}, ["*"]);
export { SocketIoComponentNgFactory as SocketIoComponentNgFactory };
//# sourceMappingURL=socket-io.component.ngfactory.js.map